<template>
  <div class="container">
    <div style="width: 100%; height: 100%" ref="container">
      <div class="first" @mousewheel="scrollToSecond" @touchmove="scrollToSecond">
        <div class="banner flex">
          <div class="banner-content">
            <div class="banner-title">SecBench 网络安全大模型评测</div>
            <p class="banner-text">
              腾讯朱雀实验室和腾讯安全科恩实验室联合清华大学江勇教授/夏树涛教授团队、香港理工大学罗夏朴教授研究团队以及上海人工智能实验室OpenCompass团队，共同建设业界首个网络安全大模型评测平台SecBench，旨在为大模型在安全领域的落地应用选择基座模型提供参考，加速大模型落地进程。同时，通过建设安全大模型评测基准，为安全大模型研发提供公平、公正、客观、全面的评测能力，推动安全大模型建设。
            </p>
            <div>
              <!--el-button type="primary" class="banner-btn" @click="jumpToBoard('eval')">
                在线评测
              </el-button-->
              <el-button type="primary" class="banner-btn" @click="jumpToBoard(undefined)">
                查看最新排行榜
              </el-button>
            </div>
            <div class="logos"></div>
          </div>
        </div>
        <div class="advantage flex">
          <div>
            <div class="block-title">优势特点</div>
            <div class="flex advantage-div">
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-1"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">覆盖多个安全领域评测</div>
                  <div class="advantage-text">
                    从网络安全垂直领域的视角，评测大模型在数据安全、应用安全等多个安全领域的能力
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-2"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">涵盖多语言、多评测形式</div>
                  <div class="advantage-text">
                    评测大模型在中文、英文两种语言，选择题和问答题两种题型的能力
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-3"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">全面评估大模型能力</div>
                  <div class="advantage-text">
                    从大模型基础能力视角，评测大模型对通用安全问题的知识记忆和逻辑推理能力
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second" ref="second" @mousewheel="scrollToFirst" @touchmove="scrollToFirst">
        <div class="block-title">独家安全评测数据集</div>
        <div class="banner-text ma width dataset-text">
          网络安全大模型评测套件使用独家构建的安全评测数据集，涵盖中英文两种语言，选择和问答两种题型，已累计评测题目近5万道。覆盖多个安全领域，包括安全管理、数据安全、网络与基础架构安全、安全标准与法规、应用安全、身份与访问控制、基础软硬件与技术、端点与主机安全、云安全等，全方位量化大模型在网络安全领域知识记忆、逻辑推理能力。
        </div>
        <div class="dataset-img"></div>
        <div class="tac more-dataset">
          <el-link type="primary" href="/dataset" :underline="false">
            查看评测数据集&nbsp;&gt;
          </el-link>
        </div>
        <div class="advantage cooperate">
          <div class="advantage-div">
            <div class="block-title tac">我们的合作伙伴</div>
            <div class="flex cooperate-div">
              <div class="advantage-content flex">
                <div class="cooperate-img cooperate-img-0"></div>
              </div>
              <div class="advantage-content flex">
                <div class="cooperate-img cooperate-img-1"></div>
              </div>
              <div class="advantage-content flex">
                <div class="cooperate-img cooperate-img-2"></div>
              </div>
              <div class="advantage-content flex">
                <div class="cooperate-img cooperate-img-3"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="connect">
          <div class="connect-content tac">
            <div class="connect">
              <div>如有数据集共建、合作、评测需求，请联系：</div>
              <div>
                <el-link
                  style="color: #1ba9f9 !important"
                  type="primary"
                  href="mailto: secbench@tencent.com"
                  target="_blank"
                >
                  secbench@tencent.com
                </el-link>
              </div>
            </div>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
    <el-dialog :title="curDataset.dataset_name" :visible.sync="datasetVisible" width="30%">
      <json-viewer :value="{ data: curDataset.data_example }" :expand-depth="5" copyable>
      </json-viewer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="datasetVisible = false" size="small" class="dataset-btn">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageFooter from '@/components/Footer';
import { doHttp } from '@/common/simple_http';
import JsonViewer from 'vue-json-viewer';

export default {
  components: {
    PageFooter,
    JsonViewer,
  },
  data() {
    return {
      dataset: [],
      curDataset: {},
      datasetVisible: false,
      contributors: [],
    };
  },
  created: function () {
    // this.getDataset();
    this.getContributor();
  },
  mounted() {},
  methods: {
    scrollToSecond(event) {
      if (event.deltaY > 0) {
        // 滚动到下一屏
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, -100%, 0px);'
        );
      }
    },
    scrollToFirst(e) {
      if (e.deltaY < 0 && this.$refs.second.scrollTop === 0) {
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, 0%, 0px);'
        );
      }
    },
    getDataset() {
      doHttp('/data/getOtherInfo', 'post', { group: 'Dataset_Infos' }, (rst) => {
        rst.data.sort((n1, n2) => {
          return parseInt(n2.count) - parseInt(n1.count);
        });
        this.dataset = rst.data.slice(0, 6).map((item) => {
          item.data_example = JSON.parse(item.data_example);
          item.data_type = item.data_type.split('/');
          return item;
        });
      });
    },
    openDataset(idx) {
      this.curDataset = this.dataset[idx];
      this.datasetVisible = true;
    },
    jumpToBoard(action) {
      this.$router.push({
        path: `/board`,
        query: {
          action: action,
        },
      });
    },
    getContributor() {
      doHttp('/data/getContributor', 'post', {}, (rst) => {
        let { contributors } = this;
        contributors = rst.data
          .sort((n1, n2) => {
            return n2.score - n1.score;
          })
          .slice(0, 3);
        [contributors[0], contributors[1]] = [contributors[1], contributors[0]];
        this.contributors = contributors;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/_var.less';
@import '~@/assets/styles/_mixin.less';

.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .first,
  .second {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .second {
    padding-top: 95px;
  }
}
.el-button--primary {
  background-color: @color-primary;
  border-color: @color-primary;
}
.block-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  font-family: TencentSans;
  text-align: center;
  padding: 0 0 40px 0;
}
.banner-text {
  line-height: 22px;
  color: rgba(82, 92, 114, 0.9);
  font-weight: 400;
  max-width: 780px;
  font-family: Source Han Sans CN;
}

.banner {
  background: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/banner.png)
      center 23px / auto 100% no-repeat,
    linear-gradient(72deg, rgb(221, 232, 240) 0%, rgb(223, 233, 241) 100%);
  width: 100%;
  height: calc(100vh / 2);
  min-height: 400px;
  .align-items();
  .justify-content(center);
  .banner-content {
    width: @width;
    .banner-title {
      color: @color-primary;
      font-size: 40px;
      line-height: 60px;
      margin-top: 20px;
      font-family: TencentSans;
      font-weight: 700;
    }
    .banner-btn {
      margin-top: 10px;
      &:first-of-type {
        margin-right: 20px;
      }
    }
    .logos {
      margin-top: 47px;
      background-image: url('../../assets/images/logos.png');
      background-size: contain;
      background-repeat: no-repeat;
      width: 366px;
      height: 32px;
    }
  }
}

.advantage {
  background: #fff;
  width: 100%;
  height: calc(100vh - 400px);
  .align-items();
  max-height: calc(100vh / 2);
  & > div {
    margin: auto;
  }
}
.advantage-div {
  .justify-content(space-between);
  width: @width;
  margin: auto;
  .advantage-content {
    width: 380px;
    height: 150px;
    padding: 20px;
    background: linear-gradient(180deg, #f2f3f6 0%, rgba(242, 243, 246, 0) 54.93%);
    border: 1px solid rgba(243, 244, 246, 1);
    .advantage-img {
      width: 84px;
      height: 84px;
      background-size: contain;
      background-repeat: no-repeat;
      &.advantage-img-1 {
        background-image: url(../../assets/images/advantage_1.png);
      }
      &.advantage-img-2 {
        background-image: url(../../assets/images/advantage_2.png);
      }
      &.advantage-img-3 {
        background-image: url(../../assets/images/advantage_3.png);
      }
    }
    .advantage-content-div {
      padding: 0 10px;
      width: calc(100% - 84px);
      .advantage-text {
        color: #848c9b;
        line-height: 20px;
        padding-top: 8px;
      }
    }
    .advantage-sub-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: #252831;
    }
  }
}
.width {
  width: @width;
}
.dataset-text {
  max-width: @width;
}
.dataset-img {
  width: @width;
  height: 644px;
  background-image: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/banner.png);
  background-size: 744px 553px;
  background-repeat: no-repeat;
  background-position: 50%;
  margin: 20px auto 20px auto;
  border: 2px solid #fff;
  background-color: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
    linear-gradient(0deg, #fff, #fff);
  box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
  background: url(../../assets/images/dataset.png) center center / 744px 553px no-repeat,
    linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%), linear-gradient(0deg, #fff, #fff);
}
.dataset-list {
  width: @width;
  flex-wrap: wrap;
  margin-top: 40px;
  & > div {
    margin-bottom: 25px;
    height: 205px !important;
    padding: 24px 20px !important;
    box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 1), 8px 8px 20px 0px rgba(55, 99, 170, 0.1) !important;
    border: 2px solid rgba(255, 255, 255, 1) !important;
    background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%) !important;
  }
}
.tag {
  background: rgb(219, 232, 255);
  padding: 0 8px;
  border: none;
  border-radius: 0;
  color: @color-primary;
  height: 20px;
  line-height: 20px;
}
.dataset-tips {
  color: #aaa;
  line-height: 20px;
}
.dataset-divider {
  padding: 0 10px;
}
.show-data {
  color: @color-primary;
  line-height: 20px;
  cursor: pointer;
}
.dataset-info {
  .justify-content(space-between);
  padding: 20px 0 10px 0;
}
/deep/.dataset-des {
  button {
    width: 100%;
    text-align: left;
    span {
      color: #848c9b;
      font-weight: 400;
      width: 100%;
      display: -webkit-box;
      height: 66px;
      line-height: 22px;
      overflow: hidden;
      white-space: normal !important;
      word-break: break-all;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.cooperate {
  background: #fff;
  margin-top: 40px;
  padding: 50px 0 60px 0;
  height: auto;
  max-height: none;
  .block-title {
    padding-bottom: 26px;
  }
}
.cooperate-div {
  .justify-content(space-between);
  .advantage-content {
    box-shadow: 0px 8px 20px 0px rgba(55, 99, 170, 0.12), 0px -2px 20px 0px rgba(55, 99, 170, 0.02);
    background: #fff;
    border: none;
    height: 132px;
    width: 280px;
    .align-items;
    .justify-content(center);
  }
  .cooperate-img {
    background-size: contain;
    background-repeat: no-repeat;
  }
  .cooperate-img-0 {
    width: 170px;
    height: 44px;
    background-image: url(../../assets/images/co_0.png);
  }
  .cooperate-img-1 {
    width: 162px;
    height: 51px;
    background-image: url(../../assets/images/co_1.png);
  }
  .cooperate-img-2 {
    width: 240px;
    height: 46px;
    background-image: url(../../assets/images/co_2.png);
  }
  .cooperate-img-3 {
    width: 238px;
    height: 41px;
    background-image: url(../../assets/images/co_3.png);
  }
}
.connect-content {
  background: #242933;
  .connect {
    font-size: 28px;
    line-height: 42px;
    font-weight: 700;
    color: #fff;
    font-family: TencentSans;
    background-image: url(../../assets/images/connect.png);
    background-repeat: no-repeat;
    background-size: 376px 234px;
    background-position-y: 27px;
    margin: auto;
    width: @width;
    height: 100%;
    padding: 60px 0;
    .el-link {
      font-size: 28px;
      line-height: 42px;
      font-weight: 300;
    }
  }
}
.dataset-btn {
  width: 88px;
}
.more-dataset {
  color: @color-primary;
  font-size: 16px;
  line-height: 22px;
  margin-top: 40px;
  .el-link.el-link--primary {
    font-size: 16px;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
.contributor {
  max-height: 560px !important;
  height: 560px !important;
  margin-top: 50px;
  background: #fff;
  padding: 50px;
  & > div {
    height: 400px;
    .contributor-div {
      width: 850px;
      margin: auto;
      margin-top: 20px;
      .justify-content(space-between);
      & > div {
        &:hover {
          transform: scale(1.05);
        }
        transition: transform 1s ease 0s, -webkit-transform 1s ease 0s;
        width: 250px;
        height: 270px;
        box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6),
          8px 8px 20px 0px rgba(55, 99, 170, 0.1);
        border-radius: 20px;
        border: 2px solid #fff;
        background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%);
        background: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
          linear-gradient(0deg, #fff, #fff);
        &:nth-of-type(2) {
          height: 300px;
        }
        & > div {
          text-align: center;
        }
        .avator {
          width: 115px;
          height: 115px;
          margin: 45px auto auto auto;
          border-radius: 50%;
          & > div {
            width: 100px;
            height: 100px;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 50%;
            margin: auto;
          }
          &.avator-1 {
            border: 5px solid #b6bfcd;
          }
          &.avator-2 {
            margin: 25px auto auto auto;
            width: 135px;
            height: 135px;
            border: 5px solid #f3d04b;
            & > div {
              width: 120px;
              height: 120px;
            }
          }
          &.avator-3 {
            border: 5px solid #b0763c;
          }
        }
        .username {
          padding-top: 10px;
          font-size: 16px;
          font-weight: 700;
        }
        .score {
          padding-top: 10px;
          font-weight: 700;
          &.score-1 {
            color: #b6bfcd;
          }
          &.score-2 {
            color: #f3d04b;
          }
          &.score-3 {
            color: #b0763c;
          }
          .score-item {
            font-family: TCloud Number;
            font-size: 18px;
            font-weight: bold;
            padding-right: 3px;
          }
        }
      }
    }
  }
  .more-dataset {
    margin-top: 30px;
  }
}
</style>
